import { render, staticRenderFns } from "./kaoshi.vue?vue&type=template&id=acee280a&scoped=true"
import script from "./kaoshi.vue?vue&type=script&lang=js"
export * from "./kaoshi.vue?vue&type=script&lang=js"
import style0 from "./kaoshi.vue?vue&type=style&index=0&id=acee280a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acee280a",
  null
  
)

export default component.exports